import { getService } from "../api-service";
import { BASE_URL } from "../environment_url";

//***** User API Endpoints  ******//

const GET_USER = "/users/"

export function getUser(emailId) {
    const getUserUrl = BASE_URL + GET_USER 
    return getService(getUserUrl,emailId);
}
